import { css, html } from "../helpers/webComponents";
import { CalculatorService } from "../services/CalculatorService";

const styles: string = css`
    .modal {
        position: fixed;
        bottom: 20px; 
        left: 20px; 
        transform: none;
        background: white;
        padding: 20px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        z-index: 1000;
        opacity: 1;
        transition: opacity 0.3s ease;
    }
    .calculator {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 5px;
        width: 160px;
    }
    button {
        width: 40px;
        height: 40px;
        font-size: 16px;
        color: black;
    }
    .display {
        font-size: 20px;
        margin-bottom: 10px;
        text-align: right;
        padding: 10px;
        background: #000000;
        color: white;
        border-radius: 5px;
    }
    .action-buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
    }
    .close-button {
        background: red;
        color: white;
        border: none;
        border-radius: 5px;
        width: 40px;
        height: 40px;
        font-size: 16px;
        cursor: pointer;
    }
    .submit-button {
        background: green;
        color: white;
        border: none;
        border-radius: 5px;
        width: 40px;
        height: 40px;
        font-size: 16px;
        cursor: pointer;
    }
`;

export class CalculatorComponent extends HTMLElement {
    private CalculatorService: CalculatorService = new CalculatorService();
    private inputValue: string = "";

    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
    }

    public connectedCallback(): void {
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const element: HTMLElement = this.renderCalculator();
        this.shadowRoot.innerHTML = "";
        this.shadowRoot.appendChild(element);
    }

    private renderCalculator(): HTMLElement {
        const element: HTMLElement = html`
        <div>
            <style>
                ${styles}
            </style>
            <div class="modal">
                <div class="display">${this.inputValue || "0"}</div>
                <div class="calculator">
                    <button data-value="7">7</button>
                    <button data-value="8">8</button>
                    <button data-value="9">9</button>
                    <button data-value="/">/</button>
                    <button data-value="4">4</button>
                    <button data-value="5">5</button>
                    <button data-value="6">6</button>
                    <button data-value="*">*</button>
                    <button data-value="1">1</button>
                    <button data-value="2">2</button>
                    <button data-value="3">3</button>
                    <button data-value="-">-</button>
                    <button data-value="0">0</button>
                    <button data-value="C">C</button>
                    <button data-value="=">=</button>
                    <button data-value="+">+</button>
                </div>
                <div class="action-buttons">
                    <button class="close-button">X</button>
                </div>
            </div>
        </div>`;

        this.addEventListeners(element);
        return element;
    }

    private addEventListeners(element: HTMLElement): void {
        element.querySelectorAll("button").forEach(button => {
            button.addEventListener("click", (event: Event) => {
                const target: EventTarget | null = event.target;
                if (target instanceof HTMLButtonElement) {
                    const value: string | undefined = target.dataset.value;
                    if (value !== undefined) {
                        void this.handleInput(value);
                    }
                }
            });
        });

        const closeButton: HTMLButtonElement | null = element.querySelector(".close-button");
        if (closeButton) {
            closeButton.addEventListener("click", () => {
                this.removeCalculator();
            });
        }
    }

    private async handleInput(value: string): Promise<void> {
        if (value === "C") {
            this.inputValue = "";
        }
        else if (value === "=") {
            try {
                const result: string = await this.CalculatorService.calculate(this.inputValue);
                this.inputValue = result;
            }
            catch {
                this.inputValue = "Error";
            }
        }
        else {
            this.inputValue += value;
        }
        this.updateDisplay();
    }

    private removeCalculator(): void {
        if (this.shadowRoot) {
            this.shadowRoot.innerHTML = "";
        }
    }

    private updateDisplay(): void {
        const displayElement: HTMLElement | null = this.shadowRoot?.querySelector(".display") ?? null;
        if (displayElement) {
            displayElement.textContent = this.inputValue || "0";
        }
    }
}
